export default __webpack_public_path__ + "static/media/api.8fe4902d.svg";